import React from 'react'

function NewsPage() {
  return (
    <main>
        <div className="main_section_1_img_wrapper">
            <img src={require("./static/img/bus.jpg")} alt="" />
            <h2 className="blur_div">
                &nbsp;
                “MARYAWTOULAG” <br />
                ÖNÜMÇILIK BIRLEŞIGI
                <img src={require("./static/img/arrow_down.png")} alt="" />
            </h2>
        </div>


        <div className="news_title_section">
            <h2>TÄZELIKLER</h2>
            <img src={require("./static/img/element2.png")} className="" alt="" />
        </div>

        <div className="news_wrapper">
            <div className="news_card">
                <a href="single_news.html">
                    <img src={require("./static/img/element3.jpg")} className="news_card_decoration_img" alt="" />
                    <img className="news_image" src={require("./static/img/news_example_1.jpg")} alt="" />
                    <div className="news_card_inner_wrapper">
                        <div className="news_card_text_wrapper">
                            <p className="news_card_date">12.11.2022</p>
                            <h5 className="news_card_title">Türkmen samboçylary Bişkek şäherinde geçirilýän dünýä çempionatynda altyn we bürünç medallarynyň ikisini gazandylar</h5>
                            <p className="news_card_content">Türkmen samboçylary Gyrgyz Respublikasynyň Bişkek şäherinde dowam edýän 47-nji Sambo boýunça dünýä</p>

                        </div>
                        <p className="news_card_button">
                            <span>Giňişleýin</span> 
                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi-chevron-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                          </svg>
                        </p>
                    </div>
                </a>
            </div>

            <div className="news_card">
                <a href="single_news.html">
                    <img src={require("./static/img/element3.jpg")} className="news_card_decoration_img" alt="" />
                    <img className="news_image" src={require("./static/img/news_example_2.jpg")} alt="" />
                    <div className="news_card_inner_wrapper">
                        <div className="news_card_text_wrapper">
                            <p className="news_card_date">12.11.2022</p>
                            <h5 className="news_card_title">Türkmenistanda Koreý medeniýetiniň günleriniň jemleýji güni</h5>
                            <p className="news_card_content">Türkmenistanda Koreý medeniýetiniň günleri tamamlandy. Ol dostlukly halkyň döwrebap aýdym-sazlary</p>

                        </div>
                        <p className="news_card_button">
                            <span>Giňişleýin</span> 
                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi-chevron-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                          </svg>
                        </p>
                    </div>
                </a>
            </div>

            <div className="news_card">
                <a href="single_news.html">
                    <img src={require("./static/img/element3.jpg")} className="news_card_decoration_img" alt="" />
                    <img className="news_image" src={require("./static/img/news_example_3.jpg")} alt="" />
                    <div className="news_card_inner_wrapper">
                        <div className="news_card_text_wrapper">
                            <p className="news_card_date">12.11.2022</p>
                            <h5 className="news_card_title">Türkmenistanyň Milli Geňeşiniň Mejlisiniň maslahaty</h5>
                            <p className="news_card_content">Şu gün paýtagtymyzda Türkmenistanyň Milli Geňeşiniň Mejlisiniň altynjy çagyrylyşynyň ýigrimi birinji ...</p>

                        </div>
                        <p className="news_card_button">
                            <span>Giňişleýin</span> 
                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi-chevron-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                          </svg>
                        </p>
                    </div>
                </a>
            </div>

            <div className="news_card">
                <a href="#">
                    <img src={require("./static/img/element3.jpg")} className="news_card_decoration_img" alt="" />
                    <img className="news_image" src={require("./static/img/news_example_4.jpg")} alt="" />
                    <div className="news_card_inner_wrapper">
                        <div className="news_card_text_wrapper">
                            <p className="news_card_date">22.11.2022</p>
                            <h5 className="news_card_title">Türkmenistanyň ýaş figuralaýyn typyjylary buz üstündäki täze çykyşlaryny hödürlär</h5>
                            <p className="news_card_content">Täze ýyl baýramyna sanlyja gün galdy. Däp boýunça, Täze ýyl dabarasynyň öňüsyrasynda Aşgabadyň Sport ...</p>

                        </div>
                        <p className="news_card_button">
                            <span>Giňişleýin</span> 
                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi-chevron-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                          </svg>
                        </p>
                    </div>
                </a>
            </div>

            <div className="news_card">
                <a href="#">
                    <img src={require("./static/img/element3.jpg")} className="news_card_decoration_img" alt="" />
                    <img className="news_image" src={require("./static/img/news_example_5.jpg")} alt="" />
                    <div className="news_card_inner_wrapper">
                        <div className="news_card_text_wrapper">
                            <p className="news_card_date">16.11.2022</p>
                            <h5 className="news_card_title">“Ýylyň parlak ýyldyzy” estrada bäsleşiginiň ýeňijisi kesgitlenildi</h5>
                            <p className="news_card_content">Şu gün paýtagtymyzda asylly däbe görä, Täze ýyl baýramçylygynyň öňüsyrasynda geçirilýän şanly wakala ...</p>

                        </div>
                        <p className="news_card_button">
                            <span>Giňişleýin</span> 
                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi-chevron-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                          </svg>
                        </p>
                    </div>
                </a>
            </div>

            <div className="news_card">
                <a href="#">
                    <img src={require("./static/img/element3.jpg")} className="news_card_decoration_img" alt="" />
                    <img className="news_image" src={require("./static/img/news_example_6.jpg")} alt="" />
                    <div className="news_card_inner_wrapper">
                        <div className="news_card_text_wrapper">
                            <p className="news_card_date">23.11.2022</p>
                            <h5 className="news_card_title">«Şygryýet äleminiň öçmejek nury»</h5>
                            <p className="news_card_content">Şeýle at bilen Balkan welaýatynyň Magtymguly etrap merkezindäki Magtymguly Pyragynyň muzeýiniň mejli ...</p>

                        </div>
                        <p className="news_card_button">
                            <span>Giňişleýin</span> 
                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi-chevron-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                          </svg>
                        </p>
                    </div>
                </a>
            </div>
        </div>
        

    </main>
  )
}

export default NewsPage